import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { applyPalette, DEFAULT_PALETTE } from './config/palettes'

try {
  const savedPalette = localStorage.getItem('sendroli_palette') || DEFAULT_PALETTE
  const isDark = document.documentElement.getAttribute('data-theme') === 'dark'
  applyPalette(savedPalette, isDark)
} catch {
  // Ignore in environments without window/localStorage
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
